<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" />
			<span>专业园地</span><i class="el-icon-arrow-right"></i>&nbsp;<span>专业园地详情</span>
		</div>
		<div class="content">
			<div class="zy_content clearfix">
				<div class="zy_index_title">
					<img src="@/images/title_back1.png" class="zy_index_titleback" />
					<img src="@/images/plot.png" class="zy_index_titlename" />
					<div class="zy_index_titleright clearfix">
						<div class="zy_index_titlerightitem" @click="$router.back(-1)">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo">返回列表</div>
						</div>
					</div>
				</div>
				<div class="zy_maincont clearfix">
					<div class="newsHead">
						<div class="newsTitle">{{detailInfo.title}}</div>
						<div class="newsInfo">发布时间：{{detailInfo.releaseTime}}</div>
					</div>
					<div class="newsBody" v-html='detailInfo.context'>
					</div>
					<div class="newsFiles" v-if="detailInfo.enclosures && detailInfo.enclosures.length>0">
						<el-tabs v-model="activeName">
							<el-tab-pane label="相关附件" name="first">
								<!---->
								<div class="clearfix">
									<div v-for="(item,index) in detailInfo.enclosures" class="newsFiles_item text-ellipsistwo" @click="handleDownload(item)">下载附件：{{item.fileName}}</div>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { downloadFile } from "@/utils/oss.js";
	import { plotContextDetail } from '@/api/majorplot.js'
	export default {
		name: 'newsdetail',
		data() {
			return {
				activeName:'first',
				id: this.$route.query.id,
				detailInfo: {},
			}
		},
		created() {
			this.getDetail()
		},
		methods: {
			getDetail() {
				plotContextDetail({
					contextId: this.id
				}).then(res => {
					this.detailInfo = Object.assign({}, res.data, {
						plodIds: res.data.plodIds ? res.data.plodIds.split(',') : [],
						enclosures: res.data.enclosure ? JSON.parse(res.data.enclosure) : [],
					})
				})
			},
			//附件下载
			handleDownload(item) {
				var fileUrl = item.fileUrl;
				var fileName = item.fileName;
				downloadFile(fileUrl, fileName)
			},
		},
	}
</script>